<template class="temp-footer">
  <footer>

    <p class="title">Se inscreva para receber nossas novidades!</p>

    <p class="title">Siga a Empório</p>

    <div class="line">
      <p><a href="https://www.facebook.com/emporiomarcasrn">Facebook</a></p>
      <p><a href="https://www.instagram.com/emporiodasmarcas_">Instagram</a></p>
      <p><a href="https://wa.me/5584998918464">WhatsApp</a></p>
    </div>

    <p class="title"><router-link :to="`/politica-privacidade`">Política de Privacidade</router-link></p>
    
    <p class="copyright-footer">© 2025, Empório Marcas. Todos os direitos reservados. | Av. Brigadeiro Eduardo Gomes, 250. Emaús, Parnamirim. RN CEP: 59149-390</p>
  </footer>
</template>

<script>
export default {
  name: "Footerr",
  props: ["categorias"],
  data() {
    return{

    }
  }
};
</script>

<style>
footer {
  width: 100%;
  padding: 20px 10px;
  background-color: #FFFFFF;
  color: #191919;
  /* display: flex; */
  justify-self: center;
  align-self: center;
}

footer .title{
  margin: 50px 0;
}

.line{
  margin: 10px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 20%;
  justify-self: center;
}

.line p {
  margin-right: 10px;
  text-transform: uppercase;
}

.title {
  color: #000000;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;  
}


footer .copyright-footer{
  font-size: 10px;
  color: #707070;
}

@media screen and (max-width: 800px) {
  footer section{
    display: flex;
    flex-direction: column;
    margin: 20px;
  }
}
</style>
